import * as React from 'react';
interface PropTypes {
    value: number,
    maxValue: number,
    showMax?: boolean,
    overDue?: boolean,
    unit?: 'hours' | 'percent',
    baseColourOnly?: boolean
}
export function UtilisationCell({value, maxValue, showMax = true, unit = 'hours', overDue = false, baseColourOnly = false}: PropTypes) {
    const valueRounded = value ? parseFloat(value.toFixed(2)) : 0;
    maxValue = Number(maxValue);
    // if (!valueRounded && maxValue)
    return (
        // <td style={{width: '4em', maxWidth: '4em'}} className={`${value > maxValue ? 'bg-danger' : value/maxValue > 0.9 ? 'bg-info' : !maxValue ? 'bg-transparent' : 'bg-info-subtle'}`}>
        //      <div className={`${value > maxValue ? 'bg-danger' : value/maxValue > 0.9 ? 'bg-info' : !maxValue ? 'bg-transparent' : 'bg-info-subtle'}`}>
        //      <div className={`${value > maxValue ? 'bg-danger' : value/maxValue > 0.9 ? 'bg-info' : !maxValue ? 'bg-transparent' : 'bg-info-subtle'}`}  style={{minWidth: '6em', maxWidth: '6em'}}>
             <div className={`${(overDue && valueRounded) ? 'bg-overdue' : (baseColourOnly && valueRounded) ? 'baseColour' : valueRounded/maxValue > 1.2 ? 'bg-danger' : (valueRounded/maxValue > 0.8 && valueRounded/maxValue <= 1.2) ? 'bg-success-subtle' : (maxValue == 0 || !maxValue) ? 'bg-transparent' : (!valueRounded && maxValue) ? 'bg-white' : 'bg-info-subtle'}`} style={{padding: '4px', height:'23px'}}>
                 {
                     unit == 'hours' ?
                         <>
                         {(maxValue || valueRounded) ? (valueRounded > 0 && valueRounded < 0.1) ? valueRounded.toFixed(2) : (valueRounded > 1000 || !valueRounded) ? valueRounded.toFixed(0) : valueRounded.toFixed(1) : ''}
                         {(maxValue || valueRounded) && showMax ?  <span className='text-body-secondary'>/{maxValue}</span> : ''}
                         </>
                         :
                         (maxValue || valueRounded) ? (valueRounded/(maxValue || valueRounded)*100).toFixed(1) : ''
                }
             </div>
        // </td>
    )
}